import styles from './menu.module.css';
import OutsideClickHandler from 'react-outside-click-handler';
import cn from 'classnames';

export default function Menu({ closeModal, setModal, modal }) {
  return (
    <OutsideClickHandler onOutsideClick={() => setModal(false)}>
      <div modal={modal} className={styles.responsive_menu}>
        <button
          className={cn('button-tiny', styles.close_button)}
          onClick={closeModal}
        >
          <svg
            width='44'
            height='44'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M8 12H16M12 8L12 16'
              strokeWidth='1'
              strokeLinecap='round'
            />
          </svg>
        </button>
        <ul className={styles.menu}></ul>
      </div>
    </OutsideClickHandler>
  );
}
